import { Outlet } from 'react-router';

export const PlansOutlet = function PlanOutlet() {
  return <Outlet />;
};
